import { useEffect } from "react";
import { useForm, FormProvider } from 'react-hook-form';
import ComponentCard from "../../components/common/ComponentCard";
import Label from "../../components/form/Label";
import Input from "../../components/form/input/InputField";
import SimplePhoneInput from "../../components/form/group-input/SimplePhoneInput";
import Button from "../../components/ui/button/Button";
import ImageInput from "../../components/form/input/ImageInput";
import { useStoreSelector } from '../../hooks/useStoreFromContext';
import AddressPicker from "../../components/form/AddressPicker";

import type { RestaurantVariables, RestaurantFormProps } from '../../types/restaurantTypes';
import type { AppState } from '../../store';

const RestaurantForm: React.FC<RestaurantFormProps> = ({ onSubmit, restaurant }) => {
  const user = useStoreSelector((s: AppState) => s.user);
  const methods = useForm<RestaurantVariables>({
    defaultValues: restaurant || {}
  });
  const { register, handleSubmit, reset, formState: { errors } } = methods;

  useEffect(() => {
    if (restaurant) reset(restaurant);
  }, [restaurant, reset]);

  return (
    <div className="grid grid-cols-1 gap-6">
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <ComponentCard title={`${restaurant?.id ? 'Edit' : 'New'} restaurant`}>
            <div className="space-y-6">
              
              <div>
                <Label htmlFor="name">Name</Label>
                <Input 
                  id="name" 
                  {...register("name", { required: "Name is required" })}
                  error={!!errors?.name}
                />
                {errors.name && <p className="text-red-500 text-xs mt-1">{errors.name.message}</p>}
              </div>

              <div>
                <Label htmlFor="website">Web site (optional)</Label>
                <Input id="website" {...register("website")} />
              </div>

              <div>
                <Label htmlFor="wifi">Wi-Fi (optional)</Label>
                <Input id="wifi" {...register("wifi")} />
              </div>

              <div>
                <Label htmlFor="phone">Phone (optional)</Label>
                <SimplePhoneInput
                  id="phone"
                  registerValue={restaurant?.phone}
                  register={register("phone")}
                  countryCode={user?.countryCode}
                />
              </div>

              <div>
                <Label htmlFor="image">Image (optional)</Label>
                <ImageInput
                  className="mt-2"
                  register={register}
                  name='image'
                  imageUrl={restaurant?.img?.medium}
                  error={errors?.image}
                />
              </div>

              <div>
                <Label htmlFor="address">Address</Label>
                <AddressPicker name="address" />
              </div>
              
              <Button size="md" variant="primary">
                {restaurant ? "Update" : "Save"}
              </Button>
            </div>
          </ComponentCard>
        </form>
      </FormProvider>
    </div>
  );
};

export default RestaurantForm;
